var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHeart = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3164_1549)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#30BBA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8016 8.73697C16.5358 8.4637 16.2203 8.24692 15.8731 8.09902C15.5258 7.95112 15.1537 7.875 14.7778 7.875C14.4019 7.875 14.0297 7.95112 13.6824 8.09902C13.3352 8.24692 13.0197 8.4637 12.754 8.73697L12.2025 9.30384L11.651 8.73697C11.1143 8.18524 10.3863 7.87529 9.62722 7.87529C8.86815 7.87529 8.14017 8.18524 7.60342 8.73697C7.06668 9.2887 6.76514 10.037 6.76514 10.8173C6.76514 11.5975 7.06668 12.3458 7.60342 12.8976L8.1549 13.4644L12.2025 17.625L16.2501 13.4644L16.8016 12.8976C17.0674 12.6244 17.2783 12.3001 17.4222 11.9432C17.5661 11.5862 17.6401 11.2036 17.6401 10.8173C17.6401 10.4309 17.5661 10.0483 17.4222 9.69136C17.2783 9.33442 17.0674 9.01011 16.8016 8.73697Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3164_1549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/heart.da9a221a71cdf2d85f984600fdbf9d77.svg";